var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contactUs"},[_c('div',{staticClass:"head"},[_c('H3',[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('ul',{staticClass:"content"},_vm._l((_vm.contactWays),function(item,i){return _c('li',{key:i},[_c('img',{attrs:{"src":item.url,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8c13bf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/contactUs.vue
// module id = null
// module chunks = 